// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"561":"33d8c811","731":"bb816977"}[chunkId] + ".chunk.css";
};